<template>
  <SuccessPoaVerification :isVerified="activeTab === registerStep.poaSuccess" />
</template>

<script>
import { mapState } from 'vuex';
import registerStep from '@/constants/register/registerStep';
import SuccessPoaVerification from '@/components/register/poaVerification/SuccessPoaVerification.vue';

export default {
  components: { SuccessPoaVerification },
  computed: { ...mapState('register', ['activeTab']) },
  created() {
    this.registerStep = registerStep;
  }
};
</script>
